<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Edit Training">
      <v-card-actions>
        <v-chip class="ma-2 float-right" color="primary"
          >Type: {{ formData.type }}</v-chip
        >
        <!-- <v-chip v-if="formData.selfInvitation=== true" class="ma-2 float-right" color="primary"
        >Self Invited</v-chip> -->
        <v-col cols="12" lg="3" v-if="formData.type === 'online'">
          <v-checkbox
            hide-details
            class="my-0 py-1"
            v-model="formData.selfInvitation"
            label="Self Invited"
          ></v-checkbox>
        </v-col>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="onSave">
          <v-row>
            <v-col cols="4" lg="4">
              <label>Training Title *</label>
              <v-text-field
                required
                color="deep-purple accent-4"
                v-model="formData.title"
                placeholder="Title"
              ></v-text-field>
            </v-col>
            <v-col cols="4" lg="4">
              <label>From Date *</label>
              <custom-date-picker
                required
                color="deep-purple accent-4"
                v-model="formData.fromDate"
                @input="fromDateChange()"
                :minToDate="currentDate"
              />
            </v-col>
            <v-col cols="4" lg="4">
              <label>To Date *</label>
              <custom-date-picker
                color="deep-purple accent-4"
                v-model="formData.toDate"
                :minToDate="formData.fromDate"
                required
              />
            </v-col>
            <v-col cols="4" lg="4">
              <label>From Time *</label>
              <v-menu
                ref="menu1"
                v-model="menu2"
                :close-on-content-click="false"
                color="deep-purple accent-4"
                :nudge-right="40"
                :return-value.sync="formData.fromTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                required
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    required
                    color="deep-purple accent-4"
                    v-model="formData.fromTime"
                    aria-required="true"
                    label="--Select Time--"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  required
                  color="deep-purple accent-4"
                  v-if="menu2"
                  v-model="formData.fromTime"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menu1.save(formData.fromTime)"
                ></v-time-picker>
              </v-menu>
            </v-col>

            <v-col cols="4" lg="4">
              <label>To Time *</label>
              <v-menu
                ref="menu2"
                v-model="menu3"
                color="deep-purple accent-4"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="formData.toTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                required
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    color="deep-purple accent-4"
                    v-model="formData.toTime"
                    aria-required="true"
                    label="--Select Time--"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    required
                  ></v-text-field>
                </template>
                <v-time-picker
                  color="deep-purple accent-4"
                  v-if="menu3"
                  v-model="formData.toTime"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menu2.save(formData.toTime)"
                  required
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="select">Select Zone *</label>
              <v-autocomplete
                disabled
                v-model="formData.zone"
                multiple
                required
                id="select"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sZone"
                :items="selectedZones"
                item-text="zone"
                item-value="zone"
                key="id"
                @input="onZoneSelect()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectS">Select States *</label>
              <v-autocomplete
                readonly
                v-model="formData.state"
                id="selectS"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sCity"
                :items="selectedState"
                item-text="state"
                item-value="state"
                key="id"
                multiple
                @input="onStateSelect()"
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectC">Select Cities *</label>
              <v-autocomplete
                readonly
                v-model="formData.city"
                id="selectC"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sCity"
                :items="selectedCity"
                item-text="city"
                item-value="city"
                key="id"
                multiple
                @input="onCitySelect()"
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectCe">Centers eligible for training *</label>
              <v-autocomplete
                readonly
                v-model="formData.franchiseeIds"
                id="selectCe"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sCenter"
                :items="selectedCenter"
                item-text="companyName"
                item-value="id"
                key="id"
                multiple
                @input="onCenterSelect()"
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectCl">Select Class Group *</label>
              <v-autocomplete
                readonly
                id="selectCl"
                v-model="formData.classGroupIDs"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sClass"
                :items="classData"
                item-text="name"
                item-value="id"
                key="id"
                multiple
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4" v-show="formData.type === 'offline'">
              <label for="selectClo">Training Location *</label>
              <v-autocomplete
                disabled
                id="selectClo"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sLocation"
                required
                :items="selectedLocation"
                item-text="companyName"
                item-value="id"
                key="id"
                v-model="formData.locationCenterID"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectT">Select Trainers *</label>
              <v-autocomplete
                id="selectT"
                v-model="formData.trainerIds"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sTrainer"
                :items="selectedTrainer"
                item-text="firstName"
                item-value="id"
                key="id"
                multiple
              ></v-autocomplete>
            </v-col>
            <v-col cols="4" lg="4">
              <label for="selectB">Batch Size *</label>
              <v-text-field
                id="selectB"
                class="my-0 py-1"
                placeholder="--Select--"
                name="sBatch"
                required
                v-model="formData.batchSize"
                key="id"
                maxLenth="100"
                :max="100"
                :min="1"
                type="number"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="4" lg="4">
              <label>Registration End Date</label>
              <custom-date-picker
                color="deep-purple accent-4"
                v-model="formData.registrationEndDate"
                :maxToDate="yesterday"
              />
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="3">Registered Staff :</v-col>
            <v-col cols="8">
              <v-row>
                <v-col
                  cols="4"
                  v-for="(enrolledUser, index) in previousSelectedStaff"
                  :key="index"
                >
                  <v-chip
                    close
                    @click:close="deregisterStaff(enrolledUser.enrollmentId)"
                    color="red"
                    text-color="white"
                    small
                    close-icon="mdi-delete"
                    >{{ enrolledUser.fullName }}</v-chip
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <label for="selectStaff">Staff List </label>
              <multiselect
                id="selectStaff"
                placeholder="Select Teachers"
                class="overflowmultiselect2"
                label="fullName"
                track-by="id"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :multiple="true"
                :options="teachersData"
                v-model="formData.staffIds"
              ></multiselect>
            </v-col>
          </v-row>
          <div class="text-right">
            <button
              type="button"
              class="button is-danger me-2"
              @click="cancelTraining()"
            >
              Cancel Training
            </button>
            <button
              type="button"
              class="button is-secondary"
              @click="$router.push({ name: 'AllTrainings' })"
            >
              Close
            </button>
            <button class="button is-success ms-2" type="submit">Save</button>
          </div>
        </form>
        <!--Received enrolments-->
        <div class="mt-2"></div>
        <div v-for="(item, i) in centersEligibleFor" :key="i">
          <v-expansion-panels>
            <v-expansion-panel v-if="enrolments[item.id]">
              <v-expansion-panel-header>{{
                item.franchisee.companyName
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-col cols="6">
                  <v-list-item
                    v-for="(teacher, k) in enrolments[item.id]"
                    :key="k"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ teacher.user.firstName }} {{ teacher.user.lastName }}
                        <!-- <v-btn title="Delete" class="px-2 ml-1 ma-1 float-right" color="error"
                          small>
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>-->
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-component>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import VCardComponent from '../template/VCardComponent.vue'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
import constants from '@/utils/constants'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  name: 'editTeacherTraining',
  props: ['id'],
  components: {
    VCardComponent,
    MaterialCard,
    CustomDatePicker,
    Multiselect
  },
  data: function () {
    return {
      formData: {
        id: '',
        title: '',
        type: 'offline',
        selfInvitation: '',
        fromDate: '',
        toDate: '',
        fromTime: '',
        toTime: '',
        state: '', // NA
        zone: '',
        city: '', // NA
        franchiseeIds: [],
        classGroupIDs: [],
        trainerIds: [],
        locationCenterID: '',
        batchSize: '',
        registrationEndDate: '',
        staffIds: []
      },
      enrolments: {},
      centersEligibleFor: [],
      currentDate: moment().format('YYYY-MM-DD'),
      selectedZones: [],
      selectedCity: [],
      selectedState: [],
      selectedCenter: [],
      selectedClass: [],
      selectedTrainer: [],
      selectedBatch: '',
      selectedLocation: [],
      maxToDate: moment().format('YYYY-MM-DD'),
      disabled: false,
      menu2: false,
      menu3: false,
      classData: [],
      isLoading: false,
      franchiseeData: [],
      selectedStates: [],
      yesterday: '',
      registeredClasses: [],
      franchiseeIDs: [],
      selectedStaff: [],
      previousSelectedStaff: [],
      teachersData: [],
      className: [],
      trainingByTrainers: null
    }
  },

  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },

  async created () {
    try {
      await this.getTrainingDetails()
      await this.getZoneDetails()
      await this.getAllTrainerList()
      await this.getClassData()
    } catch (e) {
      console.log(e)
    }
  },

  methods: {
    async onSave () {
      try {
        // if (this.validateForm()) {
        let staffids = []
        if (!_.isEmpty(this.formData.staffIds)) {
          if (this.formData.staffIds.length > this.formData.batchSize) {
            this.errMsg('Selected Staff size is greater than Batch size!')
          }
          this.formData.staffIds.map((obj) => {
            staffids.push({
              id: obj.id,
              franchiseeID: obj.franchiseeID
            })
          })
        }

        let temp = Object.assign(this.formData, {
          staffIds: staffids
        })
        delete temp.franchiseeIds
        await http.put(
          `${constants.API_URL}/api/teacher-training/update-training`,
          temp
        )

        this.$buefy.dialog.confirm({
          type: 'is-success',
          title: 'Success',
          hasIcon: true,
          message: 'Training updated successfully.',
          canCancel: [false, false, false],
          onConfirm: () => {
            this.$router.push({ name: 'AllTrainings' })
          }
        })
        // } else {
        //   this.errMsg('Please fill all the required fields!')
        // }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    async getTrainingDetails () {
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/teacher-training/get-training/${this.id}`
        )
        this.trainingByTrainers = data
        this.franchiseeIDs = [
          ...new Set(
            this.trainingByTrainers.trainingByTrainerFranchiseeMaps.map(
              (obj) => obj.franchiseeId
            )
          )
        ]

        this.formData = {
          id: data.id,
          title: data.title,
          type: data.type,
          selfInvitation: data.selfInvitation,
          fromDate: moment(data.fromDate).format('YYYY-MM-DD'),
          toDate: moment(data.toDate).format('YYYY-MM-DD'),
          fromTime: data.fromTime.substring(0, data.fromTime.length - 3),
          toTime: data.toTime.substring(0, data.toTime.length - 3),
          state: JSON.parse(data.state), // NA
          zone: await this.convertJSON(data.zone),
          city: JSON.parse(data.city), // NA
          franchiseeIds: _.map(
            data.trainingByTrainerFranchiseeMaps,
            (a) => a.franchiseeId
          ),
          classGroupIDs: _.map(
            data.trainingByTrainerClassgroupMaps,
            (a) => a.classGroupID
          ),
          trainerIds: _.map(data.trainingTrainerMaps, (a) => a.trainerUserID),
          locationCenterID: data.locationCenterID,
          batchSize: data.batchSize,
          registrationEndDate: moment(data.registrationEndDate).format(
            'YYYY-MM-DD'
          )
        }
        this.franchiseeIDs = [
          ...new Set(
            _.map(data.trainingByTrainerFranchiseeMaps, (a) => a.franchiseeId)
          )
        ]
        await this.getApprovedStaffList()
        this.yesterday = moment(this.formData.fromDate)
          .add(-1, 'days')
          .format('YYYY-MM-DD')
          .toString()
        this.centersEligibleFor = data.trainingByTrainerFranchiseeMaps
        this.enrolments = _.groupBy(
          data.trainingByTrainersEnrollments,
          'trainingFranchiseeMapID'
        )
        this.onZoneSelect()
        this.onStateSelect()
        this.onCitySelect()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    cancelTraining () {
      this.$buefy.dialog.confirm({
        type: 'is-warning',
        title: 'Alert',
        hasIcon: true,
        message: 'Are you sure to cancel this training ?',
        confirmText: 'Yes',
        cancelText: 'No',
        onConfirm: async () => {
          await http.get(
            `${constants.API_URL}/api/teacher-training/cancel-training/${this.id}`
          )
          this.$buefy.dialog.confirm({
            type: 'is-success',
            title: 'Success',
            hasIcon: true,
            message: 'Training cancelled successfully.',
            canCancel: [false, false, false],
            onConfirm: () => {
              this.$router.push({ name: 'AllTrainings' })
            }
          })
        }
      })
    },
    validateForm () {
      for (let key of Object.keys(this.formData)) {
        let exclude = []
        if (this.formData.type === 'online') {
          exclude.push('locationCenterID')
        }
        let type = typeof this.formData[key]
        if (exclude.indexOf(key) === -1) {
          if (type === 'string') {
            if (!this.formData[key]) {
              return false
            }
          } else {
            if (this.formData[key].length === 0) {
              return false
            }
          }
        }
      }
      return true
    },
    onZoneSelect () {
      this.getStateDetails()
    },

    onStateSelect () {
      this.getCityDetails()
    },

    onCitySelect () {
      this.getCenterDetails()
    },
    onCenterSelect () {
      this.getClassData()
      this.getApprovedStaffList()
    },

    onClassSelect () {
      this.getAllTrainerList()
    },

    fromDateChange () {
      this.yesterday = moment(this.formData.fromDate)
        .add(-1, 'days')
        .format('YYYY-MM-DD')
        .toString()
      this.formData.registrationEndDate = this.yesterday
      if (moment(this.formData.fromDate).isAfter(this.formData.toDate)) {
        this.formData.toDate = this.formData.fromDate
      }
    },

    clearDetails () {
      let ref = this
      ref.$dialog.warning({
        title: 'Cancel Training',
        text: 'Do you really want to <b>Cancel</b> this training?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              this.formData.title = ''
              this.formData.fromDate = ''
              this.formData.toDate = ''
              this.formData.fromTime = ''
              this.formData.toTime = ''
              this.formData.zones = ''
              this.formData.state = ''
              this.formData.city = ''
              this.formData.centers = ''
              this.formData.class = ''
              this.formData.location = ''
              this.formData.trainer = ''
              this.formData.batch = ''
              this.formData.rDate = ''
            }
          }
        }
      })
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/teacher-training/zone-options`
        )

        this.selectedZones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getStateDetails: async function () {
      this.isLoading = true
      let zone = this.formData.zone

      let res = await http.post(
        `${constants.API_URL}/api/teacher-training/state-options`,
        { zone }
      )

      this.selectedState = res.data
      this.isLoading = false
    },

    getCityDetails: async function () {
      this.isLoading = true
      let states = []
      states = this.formData.state
      let res = await http.post(
        `${constants.API_URL}/api/teacher-training/city-options`,
        { states }
      )

      this.selectedCity = res.data
      this.isLoading = false
    },

    getCenterDetails: async function () {
      this.isLoading = true
      let cities = []
      cities = this.formData.city
      let res = await http.post(
        `${constants.API_URL}/api/teacher-training/franchisee-options`,
        { cities }
      )
      this.selectedCenter = res.data
      this.selectedLocation = this.selectedCenter
      this.isLoading = false
    },
    getClassData: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/student/getclass-group`
        )
        this.isLoading = false
        data = _.filter(data, (e) => {
          return (
            e.type === constants.ClassGroupTypes.teacherTraining &&
            e.isActive === true
          )
        })
        this.classData = data
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },

    getAllTrainerList: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(
          `${constants.API_URL}/api/teacher-training/trainer-options`
        )
        this.isLoading = false
        this.selectedTrainer = data
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getApprovedStaffList: async function () {
      try {
        const { data } = await http.post(
          `${constants.API_URL}/api/teacher-training/get-staff?franchiseeID=${this.franchiseeIDs}&&isTeachingStaff=true`
        )
        _.map(data, (d) => {
          d.user.fullName = `${d.user.firstName} ${d.user.lastName} (${d.franchisee.companyName})`
          d.user.franchiseeID = d.franchisee.id
          this.teachersData.push(d.user)
        })
        let alreadySelectedStaffIds = []
        _.map(this.trainingByTrainers.trainingByTrainersEnrollments, (d) => {
          let enrol = {}
          enrol.enrollmentId = d.id
          enrol.userId = d.user.id
          alreadySelectedStaffIds.push(enrol)
        })

        console.log('alreadyselected staff: ', alreadySelectedStaffIds)
        console.log(
          'teacher by trainers: ',
          this.trainingByTrainers.trainingByTrainersEnrollments
        )

        let alreadySelectedStaffDetails = []
        _.map(this.teachersData, (teacher) => {
          _.forEach(alreadySelectedStaffIds, function (user) {
            if (teacher.id === user.userId) {
              teacher.enrollmentId = user.enrollmentId
              alreadySelectedStaffDetails.push(teacher)
            }
          })
        })
        this.previousSelectedStaff = alreadySelectedStaffDetails
        console.log('previously created staff: ', this.previousSelectedStaff)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    async convertJSON (str) {
      try {
        let output = JSON.parse(str)
        return output
      } catch (e) {
        return [str]
      }
    },
    deregisterStaff: async function (enrollmentId) {
      try {
        console.log('enrollmentid', enrollmentId)
        let formData = {}
        formData.trainingId = this.trainingByTrainers.id
        formData.enrollmentId = enrollmentId
        const { data } = await http.post(
          `${constants.API_URL}/api/teacher-training/deregister-staff`,
          formData
        )
        this.$buefy.dialog.alert({
          message: data,
          type: 'is-success'
        })
        let dropIndex = _.findIndex(this.previousSelectedStaff, function (o) {
          return o.enrollmentId === enrollmentId
        })
        this.previousSelectedStaff.splice(dropIndex, 1)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.overflowmultiselect2 >>> .multiselect__tags {
  border: none;
  border-bottom: solid 0.5px gray;
}
</style>
